import api, { createApiService } from "../http";
import { RequestGetAll } from "../types/services-types/http-types";
import { IRegistryCompanies, ResponseRegistryAddFromExcel, } from "../types/services-types/registry-types";

export default class RegistryCampaniesService {
    static apiRegistryCampaniesService =  createApiService('/registry-companies')

     static async AddFromExcel(formData: FormData) {
        const response = await this.apiRegistryCampaniesService.post<ResponseRegistryAddFromExcel<IRegistryCompanies>>('/add-from-excel', formData)
        return response.data
    }

    static async Add(json: Object) {
        const response = await this.apiRegistryCampaniesService.post<IRegistryCompanies>('/add', json)
        return response.data
    }

    static async Update(data: Object) {
        const response = await this.apiRegistryCampaniesService.post<IRegistryCompanies>(`/update`, data)
        return response.data
    }

    static async Get(id: number) {
        const response = await this.apiRegistryCampaniesService.get<IRegistryCompanies>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number, page: number) {
        const response = await this.apiRegistryCampaniesService.get<RequestGetAll<IRegistryCompanies[]>>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllFilters(sort_date: "DESC" | 'ASC', limit: number, page: number, form: Object) {
        const response = await this.apiRegistryCampaniesService.get<RequestGetAll<IRegistryCompanies[]>>('/all-filters', {
            params: {
                ...form,
                sort_date,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiRegistryCampaniesService.post<number>(`/delete/${id}`)
        return response.data
    }
}